import { Loader2Icon } from "lucide-react";

import { cn } from "@krea/shared/utils";

const sizeMap = {
  sm: "size-4",
  md: "size-6",
  lg: "size-12",
  xl: "size-14",
  xxl: "size-24",
} as const;

type SpinnerSize = keyof typeof sizeMap;

function Spinner({
  className,
  size = "xl",
}: {
  className?: string;
  size?: SpinnerSize;
}) {
  return (
    <div
      className={cn("flex items-center justify-center text-primary", className)}
    >
      <Loader2Icon
        role="status"
        aria-label="Loading"
        strokeWidth={2.5}
        className={cn(sizeMap[size], "animate-spin")}
      />
    </div>
  );
}

export { Spinner };
export type { SpinnerSize };
